import React from "react";
import { TextField, InputAdornment, type TextFieldProps } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

type AdminSearchFieldProps = Omit<TextFieldProps, "size">;

const AdminSearchField: React.FC<AdminSearchFieldProps> = ({
  InputProps,
  ...rest
}) => (
  <TextField
    fullWidth
    size="small"
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon color="action" fontSize="small" />
        </InputAdornment>
      ),
      sx: { borderRadius: 2, bgcolor: "grey.50" },
      ...InputProps,
    }}
    {...rest}
  />
);

export default AdminSearchField;
